import Vue from "vue";
import MainApp from "./MainApp.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import apolloProvider from "./plugins/apollo-2";
import titleMixin from "./utils/title";

Vue.config.productionTip = false;
Vue.mixin(titleMixin);

new Vue({
  router,
  vuetify,
  apolloProvider,
  render: (h) => h(MainApp),
}).$mount("#app");
